import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Tooltip } from "@mui/material";

const Table = ({ data, mutation }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const filtered = data.filter((row) =>
    Object.values(row).join(" ").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* SEARCH */}
      <div className="mb-3">
        <input
          type="text"
          placeholder="Search..."
          className="border px-3 py-1 rounded"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto border rounded">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="p-2">Property</th>
              <th className="p-2">Zone</th>
              <th className="p-2">Sub Location</th>
              <th className="p-2">Type</th>
              <th className="p-2">Beds</th>
              <th className="p-2">Built Area</th>
              <th className="p-2">Price</th>
              <th className="p-2">Status</th>
              <th className="p-2 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((row) => (
              <tr key={row.id} className="border-t">
                <td className="p-2">{row.property_name}</td>
                <td className="p-2">{row.zone}</td>
                <td className="p-2">{row.sub_location}</td>
                <td className="p-2">{row.property_type}</td>
                <td className="p-2">{row.bed_rooms}</td>
                <td className="p-2">{row.built_up_area}</td>
                <td className="p-2">{row.sale_price}</td>
                <td className="p-2">{row.status}</td>

                <td className="p-2 text-center space-x-2">
                  <Tooltip title="Edit">
                    <button
                      onClick={() =>
                        navigate(`/admin/property-data/new?id=${row.id}`)
                      }
                      className="text-blue-600"
                    >
                      <FaEdit />
                    </button>
                  </Tooltip>

                  <Tooltip title="Delete">
                    <button
                      onClick={() => mutation.mutate(row.id)}
                      className="text-red-600"
                    >
                      <FaTrash />
                    </button>
                  </Tooltip>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td colSpan="9" className="p-3 text-center text-gray-500">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
